export interface SamplesSequencedInfoProps {
  legendData: LegendStackedBar[];
  title?: string;
  total?: string | number;
}

interface LegendBoxColor {
  [key: string]: string;
}

export interface LegendStackedBar {
  color: string;
  label: string;
}

export const LEGEND_COLOR: LegendBoxColor = {
  RECOLLECT: '#F8BE08',
  VALID: '#3F4C77',
};
